<template>
  <div>
    <h2 class="text-center text-[28px] font-semibold">重置密码</h2>
    <Form class="my-6 reset-password-form">
      <FormItem>
        <Input v-model="password" type="password" placeholder="请输入新密码，密码由数字或字母组成，不少于 8 位"></Input>
      </FormItem>
      <FormItem>
        <Input v-model="confirm" type="password" placeholder="请再次输入密码"></Input>
      </FormItem>
      <FormItem v-if="error" class="min-h-0">
        <Alert type="error" show-icon class="m-0">{{ error }}</Alert>
      </FormItem>
      <FormItem>
        <Button @click="onClickReset" type="primary" size="large" long class="h-12 rounded-md">提&nbsp;交</Button>
      </FormItem>
    </Form>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import axios from 'axios'
import getErrorMessage from '@/utils/get-error-message'
import { Message } from 'heywhale-ui'

const router = useRouter()
const password = ref('')
const confirm = ref('')
const error = ref('')

const onClickReset = async () => {
  if (password.value !== confirm.value) {
    error.value = '两次输入的密码不一致'
    return
  }
  try {
    const payload = {
      password: password.value,
      confirmPassword: confirm.value
    }
    await axios.post('/api/auth/reset', payload)
    Message.success({ content: '重置成功，请重新登录' })
    setTimeout(() => {
      router.push({ name: 'login' })
    }, 1000)
  } catch (e: any) {
    error.value = getErrorMessage(e)
  }
}
</script>

<style lang="scss">
.reset-password-form {
  .ivu-form-item {
    min-height: 48px;
    margin-bottom: 16px;
  }
  .ivu-input-wrapper {
    input {
      height: 48px !important;
    }
  }
}
</style>
